import { BrowserRouter, Routes, Route } from "react-router-dom";
import GiftCard from "./GiftCard";
import Home from "./Home";
import PageNotFound from "./PageNotFound";

// Routing is handled here
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Home />} />
        <Route path="claim_gift_card" element={<GiftCard />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
